<template>
  <div class="sidebar">
    <h4 class="sidebar__header relative mt35 mb20 flex">
      <span> {{ $t('Filter') }} </span>
      <span
        class="weight-400 sidebar__header__clear pointer sans-serif flex lh25"
        @click="resetAllFilters"
        v-show="hasActiveFilters"
      >
        <i class="material-icons cl-accent mr5">
          cancel
        </i>
        {{ $t('Clear filters') }}
      </span>
    </h4>
    <div>
      <h5 class="reservations">
        zacatek rezervace
      </h5>
      <date-pick
        v-model="dateFrom"
        :display-format="'DD.MM.YYYY HH:mm'"
        :pick-time="true"
        :format="'YYYY-MM-DD-HH-mm'"
        :is-date-disabled="isPastDate"
        @input="emitChange"
      />
      <h5 class="reservations">
        konec rezervace
      </h5>
      <date-pick
        v-if="dateFrom!==''"
        v-model="dateTo"
        :display-format="'DD.MM.YYYY HH:mm'"
        :pick-time="true"
        :format="'YYYY-MM-DD-HH-mm'"
        :is-date-disabled="isDateAfterSelected"
        @input="emitChange"
      />
    </div>
    <div
      v-for="(filter, filterIndex) in availableFilters"
      :key="filterIndex"
    >
      <h5>
        {{ $t(filterIndex + '_filter') }}
      </h5>
      <div v-if="filterIndex==='color'">
        <color-selector
          context="category"
          code="color"
          v-for="(color, index) in filter"
          :key="index"
          :variant="color"
          :selected-filters="getCurrentFilters"
          @change="$emit('changeFilter', $event)"
        />
      </div>
      <div v-else-if="filterIndex==='size'">
        <size-selector
          context="category"
          code="size"
          class="size-select mr10 mb10"
          v-for="(size, index) in sortById(filter)"
          :key="index"
          :variant="size"
          :selected-filters="getCurrentFilters"
          @change="$emit('changeFilter', $event)"
        />
      </div>
      <div v-else-if="filterIndex==='price'">
        <price-selector
          context="category"
          class="price-select mb10 block"
          code="price"
          v-for="(price, index) in filter"
          :key="index"
          :id="price.id"
          :from="price.from"
          :to="price.to"
          :content="price.label"
          :variant="price"
          :selected-filters="getCurrentFilters"
          @change="$emit('changeFilter', $event)"
        />
      </div>
      <div v-else class="sidebar__inline-selecors block">
        <generic-selector
          class="size-select mr10 mb10 block"
          :code="filterIndex"
          v-for="(option, index) in filter"
          :key="index"
          :variant="option"
          :selected-filters="getCurrentFilters"
          @change="$emit('changeFilter', $event)"
        />
      </div>
    </div>
    <!-- add the custom controls to other available filters set in config.products.defaultFilters; must be numeric field in ES
    <div v-if="filters.erin_recommends && filters.erin_recommends.length">
      <h5>
        {{ $t('Erin recommends') }}
      </h5>
      <div
        class="size-select mr10 mb10"
        v-for="(er, index) in filters.erin_recommends"
        :key="index"
        :id="er.id"
        :label="er.label"
      >{{ er.label }}</div>
    </div>
    -->
  </div>
</template>

<script>
import ColorSelector from 'theme/components/core/ColorSelector'
import SizeSelector from 'theme/components/core/SizeSelector'
import PriceSelector from 'theme/components/core/PriceSelector'
import GenericSelector from 'theme/components/core/GenericSelector'
import pickBy from 'lodash-es/pickBy'
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { isPastDate } from 'theme/components/theme/anyrent/helpers/reservationDateLimiter'
dayjs.extend(utc);

export default {
  components: {
    ColorSelector,
    SizeSelector,
    PriceSelector,
    GenericSelector,
    DatePick
  },
  data () {
    return {
      dateFrom: '',
      dateTo: ''
    }
  },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasActiveFilters () {
      return this.$store.getters['category-next/hasActiveFilters']
    },
    getCurrentFilters () {
      return this.$store.getters['category-next/getCurrentFilters']
    },
    availableFilters () {
      return pickBy(this.filters, (filter, filterType) => { return (filter.length && !this.$store.getters['category-next/getSystemFilterNames'].includes(filterType)) })
    }
  },
  mounted () {
    // synchronise vue-date-pick-elements
    const currentFilters = this.getCurrentFilters;
    if (currentFilters.availability) {
      this.dateFrom = dayjs.utc(currentFilters.availability.from).format('YYYY-MM-DD-HH-mm');
      this.dateTo = dayjs.utc(currentFilters.availability.to).format('YYYY-MM-DD-HH-mm');
    }
  },
  methods: {
    resetAllFilters () {
      this.$store.dispatch('category-next/resetSearchFilters')
      this.dateTo = ''
      this.dateFrom = ''
    },
    sortById (filters) {
      return [...filters].sort((a, b) => { return a.id - b.id })
    },
    isDateAfterSelected (date) {
      // parsing the dates with dayjs
      const selectedFromDate = dayjs(this.dateFrom, 'YYYY-MM-DD-hh-mm')
      const aDate = dayjs(date)
      return aDate < selectedFromDate;
    },
    isPastDate (date) {
      return isPastDate(date, this.dateTo)
    },
    // delete
    emitChange () {
      const reservationToUrl = `from-${this.dateFrom}-to-${this.dateTo}`
      const filterVariant = {
        id: reservationToUrl,
        from: this.dateFrom,
        to: this.dateTo,
        label: 'reservations',
        type: 'availability',
        single: true
      }
      if (this.dateTo !== '' && this.dateFrom !== '') {
        this.$emit('changeFilter', filterVariant)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rental-dates{
  color:red
}
.reservations {
  font-size: 12px;
  margin-bottom: 4px;
  }
date-pick{
  height: 30px;
}
.sidebar {
  &__header {
    justify-content: space-between;
    min-height: 47px;
    flex-wrap: wrap;
    &__clear {
      font-size: .8em;
      min-width: 102px;
      @media only screen and (min-width: 768px) and (max-width: 770px) {
        margin-top: 20px;
      }
    }
  }
.sidebar__inline-selecors{
   display: block;
}
  &__inline-selecors {
    display: flex;
  }
}
</style>
